import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import icons from '../icons';
import Item from './Item';
import { isRTL } from '../config';

var Prev =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Prev, _React$PureComponent);

  var _super = _createSuper2(Prev);

  function Prev() {
    _classCallCheck(this, Prev);

    return _super.apply(this, arguments);
  }

  _createClass(Prev, [{
    key: "renderPrev",
    value: function renderPrev() {
      var text = this.props.text;
      var rtl = isRTL();

      if (rtl) {
        return text.next || icons.AngleRight;
      }

      return text.prev || icons.AngleLeft;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onChange = _this$props.onChange,
          current = _this$props.current,
          text = _this$props.text,
          disabled = _this$props.disabled,
          isSimple = _this$props.isSimple;
      var prev = current - 1;
      var className = text.prev || isSimple ? "no-border arrow" : 'arrow';
      return (
        /*#__PURE__*/
        React.createElement(Item, {
          className: className,
          page: prev,
          disabled: disabled || prev < 1,
          onClick: onChange
        }, this.renderPrev())
      );
    }
  }]);

  return Prev;
}(React.PureComponent);

Prev.displayName = void 0;
Prev.displayName = 'ShineoutPaginationPrev';
export default Prev;